"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTagForInvoiceStatus = void 0;
const localized_strings_1 = __importDefault(require("localized-strings"));
const react_1 = __importDefault(require("react"));
const useLangContext_1 = require("../../../hooks/useLangContext");
const types_1 = require("../../../types");
const StatusTag_1 = require("../../StatusTag");
const locales = new localized_strings_1.default({
    en: {
        canceled: 'Canceled',
        paid: 'Paid',
    },
    fr: {
        canceled: 'Annulée',
        paid: 'Payée',
    },
});
const useTagForInvoiceStatus = (status) => {
    const { syncLocales } = (0, useLangContext_1.useLangContext)();
    syncLocales(locales);
    switch (status) {
        case types_1.InvoiceStatus.Canceled:
            return (react_1.default.createElement(StatusTag_1.StatusTag, { backgroundColor: "yellow.200", iconName: "cross", text: locales.canceled, textColor: "yellow.700" }));
        case types_1.InvoiceStatus.MarkedAsPaid:
        case types_1.InvoiceStatus.Paid:
            return (react_1.default.createElement(StatusTag_1.StatusTag, { backgroundColor: "green.200", iconName: "tick", text: locales.paid, textColor: "green.700" }));
        default:
            return null;
    }
};
exports.useTagForInvoiceStatus = useTagForInvoiceStatus;
